var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-checkbox w-4 h-4 text-primary transition duration-150 ease-in-out",attrs:{"type":"checkbox"},on:{"input":function($event){return _vm.$emit('input', arguments[0].target.checked)}}})}
var staticRenderFns = []

export { render, staticRenderFns }